const userHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "User Name",
    key: "UserName",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:w-56 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Organization",
    key: "Organization",
    width: "md:w-24 lg:w-24 xl:w-36 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Email",
    key: "UserEmail",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "UserMobile",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "Location",
    width: "md:w-20 lg:w-20 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Role",
    key: "RoleName",
    width: "md:w-16 lg:w-16 xl:w-20 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-12 lg:w-12 xl:w-20 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const reportCardMailHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-14 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Value Chain Partner",
    key: "PartnerName",
    width: "md:w-60 lg:w-60 xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company",
    key: "MstCompanyNames",
    width: "md:w-96 lg:w-96 xl:w-44 2xl:m-auto px-1 py-1.5 xl:mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "Attachment",
    width: "w-24 px-1 py-1.5 flex justify-center",
    width1: "text-red-500",
  },

];

const partnermapingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company",
    key: "PartnerName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Value Chain Partner",
    key: "ValueChainPartnerNames",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "actionWithOutInactive",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const companyPartnerMapingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company",
    key: "PartnerName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Value Chain Partner",
    key: "ValueChainPartnerNames",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  // {
  //   title: "Action",
  //   key: "actionWithOutInactive",
  //   width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  // },
];
const assessmentReportHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Value Chain Partner",
    key: "PartnerName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company",
    key: "MstCompanyNames",
    width: "md:w-44 lg:w-60 xl:w-[27rem] 2xl:w-[30rem] px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Reported Date",
    key: "FormattedDate",
    width: "md:w-32 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "View Report",
    key: "Report",
    width: "md:w-32 px-1 py-1.5",
    width1: "text-red-500",
  },
];

const supplierMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Logo",
    key: "SupplierLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner Id",
    key: "SupplierId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner Name",
    key: "SupplierName",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "SupplierMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "SupplierEmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const reportCardMailMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Customer",
    key: "",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Suppliers",
    key: "",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const customerMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Logo",
    key: "CustomerLogo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Customer Id",
    key: "CustomerId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Customer Name",
    key: "CustomerName",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "CustomerMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "CustomerEmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const roleMasterHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Role / Group",
    key: "RoleName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "RoleDiscription",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const questionsMasterHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic #",
    key: "TopicNumber",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question #",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center",
  },
];
const questionsDownloadHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic #",
    key: "TopicNumber",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question #",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guidance",
    key: "Guidance",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
];
const topicMasterHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-16 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic No.",
    key: "TopicNo",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-56 xl:w-72 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-16 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const downloadQuestionsAnswerHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic No.",
    key: "TopicNo",
    width: "md:w-16 lg:w-16 xl:w-20 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "TopicName",
    width: "md:w-32 lg:w-44 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question No.",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-80  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Attachments",
    key: "Attachment",
    width: " flex justify-center px-1 py-1.5 pr-5 ",

  },

];
const downloadQuestionsAnswerHeaderExcel = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic No.",
    key: "TopicNo",
    width: "md:w-16 lg:w-16 xl:w-20 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "TopicName",
    width: "md:w-32 lg:w-44 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question No.",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-80  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Attachment Document Name",
    key: "Attachment",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-80  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Page Number",
    key: "IndicatedPages",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-80  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Comments",
    key: "Comments",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-80  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Attachments",
    key: "Attachment",
    width: " flex justify-center px-1 py-1.5 pr-5 ",

  },

];
const downloadAttachmentHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Questions No.",
    key: "QuestionsNo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Questions",
    key: "Questions",
    width: "md:w-60 lg:w-72 xl:w-96 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Answer No.",
    key: "AnswerNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Attachment",
    key: "Attachment",
    width: " md:w-44 px-1 py-1.5 ",
    width1: "text-red-500",
  },
];
const moduleHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module Name",
    key: "ModuleName",
    width: "md:w-48 lg:w-54 xl:w-80  px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Relevance",
    key: "RelevanceApplicability",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-48 lg:w-54 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const partnerMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner / Company Id",
    key: "PartnerId",
    width: "md:w-28 lg:w-24 xl:w-36 whitespace-pre-line 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner / Company Name",
    key: "GridPartnerName",
    width: "md:w-32 lg:w-32 xl:w-44 whitespace-pre-line 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "Location1",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "PartnerMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "PartnerEmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "UploadAction",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },

];
const paymentInfoHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 mt-1.5 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner Name",
    key: "PartnerName",
    width: "md:w-24 mt-1.5 lg:w-40 xl:w-40 2xl:m-auto whitespace-pre-line truncate px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Payment Date",
    key: "PaymentDate",
    width: "md:w-28 mt-1.5 lg:w-28 xl:w-28 whitespace-pre-line truncate 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Bank",
    key: "Bank",
    width: "md:w-32 mt-1.5 lg:w-32 xl:w-32 truncate whitespace-pre-line break-words 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Amount",
    key: "Amount",
    width: "md:w-20 mt-1.5 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Reference No.",
    key: "ReferenceNumber",
    width: "md:w-32 mt-1.5 whitespace-pre-line truncate  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Payment Method",
    key: "PaymentMethod",
    width: "md:w-32 mt-1.5 lg:w-36 xl:w-36 whitespace-pre-line  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Proforma Invoice",
    key: "ProformaInvoice",
    width: "md:w-24 mt-1.5  whitespace-pre-line  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Tax Invoice",
    key: "TaxInvoice",
    width: "md:w-24 mt-1.5 whitespace-pre-line  2xl:m-auto px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "PaymentInfoAction",
    width: " px-1 py-1.5 pr-5 w-16",
  },
];
const companyDashboardHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Company Name",
    key: "PartnerName",
    width: "md:w-32 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Email Id",
    key: "PartnerEmailId",
    width: "md:w-44 lg:w-52 xl:w-64 2xl:w-64 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "PartnerMobileNumber",
    width: "md:w-28 lg:w-44 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "ContactPersonName",
    width: "md:w-36 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

]
const vcpNotSubmittedDashboardHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Value Chain Partner Name",
    key: "PartnerName",
    width: "md:w-36 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 whitespace-pre-line",
    // width1: "text-red-500",
  },

  {
    title: "Email Id",
    key: "PartnerEmailId",
    width: "md:w-36 lg:w-52 xl:w-64 2xl:w-64 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "PartnerMobileNumber",
    width: "md:w-24 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 whitespace-pre-line",
    // width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "ContactPersonName",
    width: "md:w-32 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 whitespace-pre-line",
    // width1: "text-red-500",
  },
  {
    title: "Deadline",
    key: "Deadline",
    width: "md:w-24 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
]
const vcpDashboardHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Value Chain Partner Name",
    key: "PartnerName",
    width: "md:w-36 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 whitespace-pre-line",
    // width1: "text-red-500",
  },

  {
    title: "Email Id",
    key: "PartnerEmailId",
    width: "md:w-44 lg:w-52 xl:w-64 2xl:w-64 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "PartnerMobileNumber",
    width: "md:w-28 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "ContactPersonName",
    width: "md:w-36 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

]

const SubmittedAssesmentDashboardHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Value Chain Partner Name",
    key: "PartnerName",
    width: "md:w-32 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Email Id",
    key: "PartnerEmailId",
    width: "md:w-44 lg:w-52 xl:w-64 2xl:w-64 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "PartnerMobileNumber",
    width: "md:w-28 lg:w-44 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "ContactPersonName",
    width: "md:w-36 lg:w-52 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "View Report",
    key: "Report",
    width: "md:w-32 px-1 py-1.5",
    // width1: "text-red-500",
  },

]

const vcpcompanyDashboardHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Company",
    key: "Company",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-40 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Invited Value Chain Partner",
    key: "PartnerName",
    width: "md:w-28 lg:w-36 xl:w-52 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Email Id",
    key: "PartnerEmailId",
    width: "md:w-32 lg:w-52 xl:w-60 2xl:w-64 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "PartnerMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "ContactPersonName",
    width: "md:w-36 lg:w-36 xl:w-48 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

]
const assessmentReportPartnerHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company Name",
    key: "PartnerName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Assessment Report",
    key: "AttachmentFile",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
]
const downloadQuestionsHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:w-32 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic #",
    key: "TopicNumber",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-24 lg:w-24 xl:w-48 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question #",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-24 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-28 lg:w-28  xl:w-48 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guidance",
    key: "Guidance",
    width: "md:w-28 lg:w-28 xl:w-48 2xl:w-60 px-1 py-1.5 xl:mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Sample Document",
    key: "Attachment",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:w-32 px-1 py-1.5",
    width1: "text-red-500",
  },
];
const downloadQuestionsXLExportHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-44 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic #",
    key: "TopicNumber",
    width: "md:w-16 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-32 xl:w-72 2xl:w-72 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question #",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-96 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guidance",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Sample Document",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Data Owner",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Response",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  // {
  //   title: "Action",
  //   key: "action",
  //   width: "px-1.5 py-1.5 flex justify-center",
  // },
];

const companyPaymentDashboardHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Value Chain Partner Name",
    key: "PartnerName",
    width: "md:w-32 lg:w-40 xl:w-52 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Email Id",
    key: "PartnerEmailId",
    width: "md:w-32 lg:w-36 xl:w-52 whitespace-pre-line 2xl:w-64 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "PartnerMobileNumber",
    width: "md:w-28 lg:w-28 xl:w-32 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
  {
    title: "Contact Person Name",
    key: "ContactPersonName",
    width: "md:w-32 lg:w-40 xl:w-52 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Fee Due (in INR)",
    key: "FeeDue",
    width: "md:w-28 lg:w-28 xl:w-40 whitespace-pre-line 2xl:w-52 px-1 py-1.5 ",
    // width1: "text-red-500",
  },
]
const documentRepositoryHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Document Name",
    key: "DocumentName",
    width: "md:w-32 lg:w-32 truncate xl:w-72 whitespace-pre-line  2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "File Name",
    key: "FileName",
    width: "md:w-36 lg:w-32 xl:w-72 truncate break-words whitespace-pre-line overflow-hidden 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Document Size",
    key: "DocumentSizeMB",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Uploaded Date & Time",
    key: "FormattedDate",
    width: "md:w-32 lg:w-32 xl:w-36 whitespace-pre-line  2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "No. Of References",
    key: "NoOfReferences",
    width: "md:w-32 lg:w-32 xl:w-36 whitespace-pre-line  2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },


  {
    title: "Action",
    key: "DeleteAction",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const noOfReferencesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Question Number",
    key: "QuestionNumber",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:w-40 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

  {
    title: "Question",
    key: "Question",
    width: "md:w-96 lg:w-96 xl:w-96 2xl:w-96 px-1 py-1.5 ",
    // width1: "text-red-500",
  },

]
export {
  userHeaders,
  supplierMasterHeader,
  roleMasterHeader,
  customerMasterHeader,
  questionsMasterHeader,
  questionsDownloadHeader,
  reportCardMailMasterHeader,
  downloadQuestionsAnswerHeader,
  downloadAttachmentHeader,
  reportCardMailHeader,
  partnermapingHeader,
  companyPartnerMapingHeader,
  assessmentReportHeader,
  moduleHeader,
  partnerMasterHeader,
  topicMasterHeader,
  paymentInfoHeader,
  downloadQuestionsAnswerHeaderExcel,
  companyDashboardHeader,
  vcpDashboardHeader,
  // dashboardHeader,
  SubmittedAssesmentDashboardHeader,
  assessmentReportPartnerHeader,
  downloadQuestionsHeader,
  downloadQuestionsXLExportHeader,
  companyPaymentDashboardHeader,
  documentRepositoryHeader,
  noOfReferencesHeader,
  vcpcompanyDashboardHeader,
  vcpNotSubmittedDashboardHeader
};
